module.exports = __webpack_public_path__ + "assets/img/product-index4.94f6be17.png";